export default __webpack_public_path__ + "locales/lo-LA/ChangePortalOwner.json?hash=726cbadb321357f010e6c1d1958f97c9";